module["exports"] = [
  "محمد",
  "أحمد",
  "آسر",
  "أركان",
  "أسامة",
  "أسعد",
  "أشرف",
  "أكرم",
  "أليف",
  "أمان",
  "أمجد",
  "أمير",
  "أمين",
  "أنس",
  "أنيس",
  "أوس",
  "أيمن",
  "إسلام",
  "إيهاب",
  "إياد",
  "إياس",
  "القاسم",
  "المقداد",
  "باسل",
  "باسم",
  "بدر",
  "بدران",
  "بركات",
  "برهان",
  "بسام",
  "بسيم",
  "بشار",
  "بلال",
  "بلبل",
  "بليغ",
  "بندر",
  "بهيج",
  "تميم",
  "توفيق",
  "تيسير",
  "ثابت",
  "جابر",
  "جاد",
  "جاسر",
  "جاسم",
  "جبريل",
  "جسور",
  "جعفر",
  "جلال",
  "جليل",
  "جمال",
  "جمعة",
  "جميل",
  "جهاد",
  "جوهر",
  "حاتم",
  "حاجب",
  "حارث",
  "حازم",
  "حافظ",
  "حامد",
  "حبيب",
  "حذيفة",
  "حسام",
  "حسان",
  "حسني",
  "حسون",
  "حطاب",
  "حفيظ",
  "حكيم",
  "حلمي",
  "حليم",
  "حمدان",
  "حمدي",
  "حمزة",
  "حمودة",
  "حميد",
  "حيدرة",
  "خالد",
  "خباب",
  "خلدون",
  "خليل",
  "خيري",
  "داوود",
  "دريد",
  "ديسم",
  "ذاكر",
  "رؤوف",
  "رائد",
  "رائف",
  "رابح",
  "راتب",
  "راسم",
  "راشد",
  "راغب",
  "راكان",
  "رامز",
  "رامي",
  "ربيع",
  "رتيب",
  "رجب",
  "رزق",
  "رسلان",
  "رشاد",
  "رشدي",
  "رشيد",
  "رضا",
  "رضوان",
  "رعد",
  "رفيع",
  "رفيق",
  "ركان",
  "رمزي",
  "رمضان",
  "رنيم",
  "رياض",
  "ريان",
  "زاهر",
  "زياد",
  "زيدون",
  "زين الدين",
  "سالم",
  "سامح",
  "سامر",
  "سامي",
  "سراج",
  "سرحان",
  "سرمد",
  "سريج",
  "سعد",
  "سعيد",
  "سفيان",
  "سلامة",
  "سلمان",
  "سليم",
  "سماح",
  "سمير",
  "سهيل",
  "سيف",
  "شادي",
  "شاكر",
  "شريف",
  "شعبان",
  "شفيع",
  "شفيق",
  "شكري",
  "شكيب",
  "شمس الدين",
  "شهاب",
  "شوقي",
  "صابر",
  "صادق",
  "صبحي",
  "صبري",
  "صخر",
  "صداح",
  "صدقي",
  "صفوان",
  "صقر",
  "صلاح",
  "صهيب",
  "ضياء",
  "طارق",
  "طاهر",
  "طلال",
  "طيب",
  "ظافر",
  "عادل",
  "عارف",
  "عاشور",
  "عاصم",
  "عاصي",
  "عاطف",
  "عامر",
  "عباس",
  "عثمان",
  "عجمي",
  "عدلان",
  "عدلي",
  "عدنان",
  "عدي",
  "عرفات",
  "عرفان",
  "عز الدين",
  "عزام",
  "عزمي",
  "عزيز",
  "عطا",
  "عطية",
  "عفيف",
  "علاء",
  "علوي",
  "علي",
  "عماد",
  "عمار",
  "عمر",
  "عمران",
  "عياض",
  "غازي",
  "غانم",
  "غسان",
  "غفار",
  "غيث",
  "فؤاد",
  "فائز",
  "فاخر",
  "فادي",
  "فارس",
  "فاروق",
  "فاضل",
  "فاكر",
  "فتاح",
  "فتحي",
  "فخري",
  "فراس",
  "فرج",
  "فرحات",
  "فريد",
  "فضل",
  "فضيل",
  "فكري",
  "فهد",
  "فهمي",
  "فواز",
  "فوزي",
  "فيصل",
  "قاسم",
  "قدري",
  "قيس",
  "كاظم",
  "كامل",
  "كرم",
  "كمال",
  "لبيب",
  "لطفي",
  "ليث",
  "مأمون",
  "مؤمن",
  "مؤنس",
  "ماجد",
  "مازن",
  "مبارك",
  "مبروك",
  "مجاهد",
  "مجد",
  "مجدي",
  "مجيد",
  "محجوب",
  "محرز",
  "محسن",
  "محفوظ",
  "محمود",
  "مختار",
  "مخلص",
  "مراد",
  "مرتضى",
  "مرزوق",
  "مرسي",
  "مرشد",
  "مرعي",
  "مروان",
  "مستعين",
  "مسعد",
  "مسعود",
  "مصطفى",
  "مصعب",
  "مصلح",
  "مطيع",
  "معاذ",
  "معتز",
  "معز",
  "معين",
  "مفتاح",
  "مقداد",
  "ممتاز",
  "ممدوح",
  "منتصر",
  "منذر",
  "منصف",
  "منصور",
  "منعم",
  "منيب",
  "منير",
  "مهدي",
  "مهند",
  "مهيب",
  "ناجح",
  "ناجي",
  "نادر",
  "ناصح",
  "ناصر",
  "ناصف",
  "ناظم",
  "نافع",
  "نبيل",
  "نجيب",
  "نديم",
  "نزار",
  "نزيه",
  "نسيم",
  "نصحي",
  "نصر",
  "نضال",
  "نعمان",
  "نعيم",
  "نهاد",
  "نور الدين",
  "نوري",
  "نوفل",
  "هاشم",
  "هاني",
  "هشام",
  "هيثم",
  "هيكل",
  "وائل",
  "واصف",
  "وجدي",
  "وديع",
  "وسام",
  "وسيم",
  "وصفي",
  "وليد",
  "ياسر",
  "ياسين",
  "يافع",
  "يامن",
  "يحيى"
];
